import { render, staticRenderFns } from "./EcCheckbox.vue?vue&type=template&id=579e1e30"
import script from "./EcCheckbox.vue?vue&type=script&lang=js"
export * from "./EcCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports